import { formatPhoneNumber } from "@/utils/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/sharp-light-svg-icons";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";

const ConfirmModal: React.FC<{
  isOpen: boolean;
  title: string;
  description: string;
  app: any;
  setOpen: (isOpen: boolean) => void;
  children?: React.ReactNode;
  modalType?: "success" | "error";
}> = ({ isOpen, setOpen, title, description, app, children, modalType }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        setOpen(false);
      }}
      className="relative z-50"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative w-full flex gap-4 flex-col transform overflow-hidden bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div>
              <div
                className={`mx-auto flex size-12 items-center justify-center rounded-full ${modalType == "error" ? "bg-[var(--dialog-error-color)]" : "bg-[var(--dialog-primary-color)]"} `}
              >
                <FontAwesomeIcon
                  className="size-6 white"
                  icon={modalType == "error" ? faXmark : faCheck}
                />
              </div>
              <div className="gap-4 flex flex-col text-center sm:mt-5">
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold text-gray-900"
                >
                  {title}
                </DialogTitle>
              </div>
            </div>
            <div className="text-gray-900 homepage-text-sm">{children}</div>
            <div className="flex flex-col text-gray-500 homepage-text-sm">
              <div className="flex font-bold">{description}</div>
              {app?.resourceGroup.phone?.internationalNumber && (
                <span>
                  {formatPhoneNumber(
                    app.resourceGroup.phone?.prefix ?? "",
                    app.resourceGroup.phone?.number ?? ""
                  )}
                </span>
              )}
              {app?.resourceGroup?.email?.address && (
                <span>{app.resourceGroup.email?.address}</span>
              )}
            </div>
            <div className="w-full flex-1 flex">
              <button
                className={`py-2 disabled:opacity-20 relative gap-2 w-full justify-center items-center px-2 lg:px-3 flex text-nowrap text-xs lg:text-base 
                  ${modalType == "error" ? "bg-[var(--error-button-bg-color)]" : "bg-[var(--button-bg-color)]"}  
                  ${modalType == "error" ? "text-[var(--error-button-text-color)]" : "text-[var(--button-text-color)]"}  
                  ${modalType == "error" ? "border-[var(--error-button-border-color)]" : "border-[var(--button-border-color)]"}  
                  ${modalType == "error" ? "hover:bg-[var(--error-button-hover-bg-color)]" : "hover:bg-[var(--button-hover-bg-color)]"}  
                  ${modalType == "error" ? "hover:text-[var(--error-button-hover-text-color)]" : "hover:text-[var(--button-hover-text-color)]"}  
                  ${modalType == "error" ? "hover:border-[var(--error-button-hover-border-color)]" : "hover:border-[var(--button-hover-border-color)]"}
                  ${modalType == "error" ? "data-[active=active]:bg-[var(--error-button-active-bg-color)]" : "data-[active=active]:bg-[var(--button-active-bg-color)]"}  
                  ${modalType == "error" ? "data-[active=active]:text-[var(--error-button-active-text-color)]" : "data-[active=active]:text-[var(--button-active-text-color)]"}
                  ${modalType == "error" ? "data-[active=active]:border-[var(--error-button-active-border-color)]" : "data-[active=active]:border-[var(--button-active-border-color)]"}`}
                onClick={() => setOpen(false)}
              >
                Luk
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmModal;
